export default __webpack_public_path__ + "static/media/agenday-and-screenplay.23d3c595.svg";